/**
 * Normalizes question/answer text from API (strip wiki-style markup).
 * Strips "|Name" suffix so "Selva (director)|Selva" displays as "Selva (director)".
 */
export function tidyText(text) {
  if (!text || typeof text !== 'string') return '';
  return text
    .replaceAll('[[', " '")
    .replaceAll(']]', "' ")
    .replaceAll('<small>', '')
    .replaceAll('</small>', '')
    .replaceAll('<br>', ' ')
    .replaceAll('<br />', ' ')
    .replaceAll(', Is this ', ', is this ')
    .replaceAll(/<ref [^>]+>(.*?)<\/ref>/g, '')
    .replaceAll(/{{(.*?)}}/g, '')
    .replaceAll(/<ref (.*?)\/>/g, '')
    // "Name (role)|Name" → "Name (role)" only when pipe follows (role), so rest of sentence is kept
    .replace(/(\([^)]+\))\|[^|\[\]']+/g, '$1');
}
